import { ReactNode } from 'react'

/**
 * One labelled row of a details card — organisation, team, profile and user
 * summaries are all built from these. Sits inside a
 * `divide-y divide-dashed divide-gray-100` container, which each card supplies.
 *
 * labelWidth is a prop only because the existing cards were built with different
 * label columns; pass the width the surrounding card already uses rather than
 * mixing two widths in one card.
 */
export default function DetailRow({
    label,
    labelWidth = 'w-28',
    children
}: {
    label: string
    labelWidth?: string
    children: ReactNode
}) {
    return (
        <div className="flex gap-3 py-2">
            <span className={`${labelWidth} flex-none text-xs text-gray-800`}>{label}</span>
            <span className="text-sm text-gray-900">{children}</span>
        </div>
    )
}
